﻿import { DonorType } from '../enums/index';

export interface IDonorCompliance {
    id: number;
    alias: string;
    donorType: DonorType;
    isAdp: boolean;
    recipientId: number;
    complianceIssues: string[];
}
